import React, { useCallback, useEffect, useState } from "react";
import styles from "./NoInternet.module.css";

function getInitialOnline() {
  if (typeof navigator === "undefined") return true;
  return navigator.onLine;
}

const NoInternet = () => {
  const [online, setOnline] = useState(getInitialOnline);

  const sync = useCallback(() => {
    setOnline(typeof navigator !== "undefined" && navigator.onLine);
  }, []);

  useEffect(() => {
    window.addEventListener("online", sync);
    window.addEventListener("offline", sync);
    return () => {
      window.removeEventListener("online", sync);
      window.removeEventListener("offline", sync);
    };
  }, [sync]);

  if (online) return null;

  return (
    <div className={styles.overlay} role="alert" aria-live="polite">
      <div className={styles.inner}>
        <div className={styles.icon} aria-hidden>
          📡
        </div>
        <h1 className={styles.title}>You&apos;re offline</h1>
        <p className={styles.message}>
          Check your internet connection. When you&apos;re back online, this
          message will disappear automatically.
        </p>
        <button type="button" className={styles.retry} onClick={sync}>
          Try again
        </button>
      </div>
    </div>
  );
};

export default NoInternet;
